
export interface DateRange {
  start: string;
  end: string;
  label: string;
}

export const getDateRange = (range: string): DateRange => {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  
  switch (range) {
    case 'today':
      return {
        start: today.toISOString(),
        end: new Date(today.getTime() + 24 * 60 * 60 * 1000 - 1).toISOString(),
        label: 'Vandaag'
      };
      
    case 'yesterday':
      const yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000);
      return {
        start: yesterday.toISOString(),
        end: new Date(yesterday.getTime() + 24 * 60 * 60 * 1000 - 1).toISOString(),
        label: 'Gister'
      };
      
    case 'last7days':
      const last7Days = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000);
      return {
        start: last7Days.toISOString(),
        end: new Date(today.getTime() + 24 * 60 * 60 * 1000 - 1).toISOString(),
        label: 'Afgelopen 7 dagen'
      };
      
    case 'thisWeek':
      const startOfWeek = new Date(today);
      startOfWeek.setDate(today.getDate() - today.getDay() + 1); // Monday
      return {
        start: startOfWeek.toISOString(),
        end: new Date(today.getTime() + 24 * 60 * 60 * 1000 - 1).toISOString(),
        label: 'Deze week'
      };
      
    case 'lastWeek':
      const lastWeekStart = new Date(today);
      lastWeekStart.setDate(today.getDate() - today.getDay() - 6); // Previous Monday
      const lastWeekEnd = new Date(lastWeekStart);
      lastWeekEnd.setDate(lastWeekStart.getDate() + 6); // Previous Sunday
      return {
        start: lastWeekStart.toISOString(),
        end: new Date(lastWeekEnd.getTime() + 24 * 60 * 60 * 1000 - 1).toISOString(),
        label: 'Vorige week'
      };
      
    case 'thisMonth':
      const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      return {
        start: startOfMonth.toISOString(),
        end: new Date(today.getTime() + 24 * 60 * 60 * 1000 - 1).toISOString(),
        label: 'Deze maand'
      };
      
    case 'lastMonth':
      const lastMonthStart = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0);
      return {
        start: lastMonthStart.toISOString(),
        end: new Date(lastMonthEnd.getTime() + 24 * 60 * 60 * 1000 - 1).toISOString(),
        label: 'Vorige maand'
      };
      
    case 'last30days':
      const last30Days = new Date(today.getTime() - 30 * 24 * 60 * 60 * 1000);
      return {
        start: last30Days.toISOString(),
        end: new Date(today.getTime() + 24 * 60 * 60 * 1000 - 1).toISOString(),
        label: 'Afgelopen 30 dagen'
      };
      
    default:
      return getDateRange('today');
  }
};

export const formatDateForDisplay = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString('nl-NL', {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  });
};
